export const SuperPanelPanelSidebarData = [
  {
    title: "MANAGE EMPLOYEE",
    link: "manageEmployee",
  },
  {
    title: "PAYROLL",
    link: "payRoll",
  },
  {
    title: "COMPANY",
    subNav: [
      {
        title: "ADD COMPANY",
        path: "addCompany",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DESIGNATION",
        path: "editDeleteCompany",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DEPARTMENT",
    subNav: [
      {
        title: "ADD DEPARTMENT",
        path: "addDepartment",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DEPARTMENT",
        path: "editDeleteDepartment",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB DEPARTMENT",
    subNav: [
      {
        title: "ADD SUB DEPARTMENT",
        path: "addSubDepartment",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE SUB DEPARTMENT",
        path: "editSubDepartment",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DESIGNATION",
    subNav: [
      {
        title: "ADD DESIGNATION",
        path: "addDesignation",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DESIGNATION",
        path: "editDeleteDesignation",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ACTIVE USER",
    link: "activeUser",
  },
  {
    title: "SALARY ANALYSIS",
    link: "payRollCtc",
  },
  {
    title: "POLICY UPLOAD",
    link: "addUpdatePolicy",
  },
  {
    title: "KRA/KPI",
    link: "addKraKpi",
  },
  {
    title: "ABOUT US",
    link: "aboutus",
  },
  {
    title: "Onboarding Form",
    link: "onboardingForm",
  },
  {
    title: "TALKTIME ANALYSIS",
    subNav: [
      {
        title: "COUNSELLOR TALKTIME",
        path: "counsellorTalktime",
        cName: "sub-nav",
      },
      {
        title: "HR TALKTIME",
        path: "hrTalktime",
        cName: "sub-nav",
      },
      {
        title: "BDE TALKTIME",
        path: "bdeTalktime",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SALES VP DASHBOARD",
    link: "salesVPDashboard",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const SuperPanelEmployeeSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "MANAGE EMPLOYEE",
    link: "manageEmployee",
  },
  {
    title: "PAYROLL",
    link: "payRoll",
  },
  {
    title: "COMPANY",
    subNav: [
      {
        title: "ADD COMPANY",
        path: "addCompany",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DESIGNATION",
        path: "editDeleteCompany",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DEPARTMENT",
    subNav: [
      {
        title: "ADD DEPARTMENT",
        path: "addDepartment",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DEPARTMENT",
        path: "editDeleteDepartment",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB DEPARTMENT",
    subNav: [
      {
        title: "ADD SUB DEPARTMENT",
        path: "addSubDepartment",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE SUB DEPARTMENT",
        path: "editSubDepartment",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "DESIGNATION",
    subNav: [
      {
        title: "ADD DESIGNATION",
        path: "addDesignation",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE DESIGNATION",
        path: "editDeleteDesignation",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SALARY ANALYSIS",
    link: "payRollCtc",
  },
  {
    title: "KRA/KPI",
    link: "addKraKpi",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ABOUT US",
    link: "aboutus",
  },
  {
    title: "Onboarding Form",
    link: "onboardingForm",
  },
  {
    title: "TALKTIME ANALYSIS",
    subNav: [
      {
        title: "COUNSELLOR TALKTIME",
        path: "counsellorTalktime",
        cName: "sub-nav",
      },
      {
        title: "HR TALKTIME",
        path: "hrTalktime",
        cName: "sub-nav",
      },
      {
        title: "BDE TALKTIME",
        path: "bdeTalktime",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SALES VP DASHBOARD",
    link: "salesVPDashboard",
  },
];
